//React And GLOBAL CSS
import React, { useEffect, useState } from 'react';
import GConf from './AssetsM/generalConf';
import LoadingBar from 'react-top-loading-bar'
import { toast, ToastContainer } from 'react-toastify';
import { BrowserRouter as Router,Routes,Route, Outlet} from "react-router-dom";
import { Navigate } from 'react-router-dom';


// /*CSS*/
import 'bootstrap-icons/font/bootstrap-icons.css';
import './AssetsM/theme.css';
import "gridjs/dist/theme/mermaid.css";
import 'react-toastify/dist/ReactToastify.css';
 
//Landing Page
import LandingPage from './Routing/Landing/landingPage'

// ADMIN PAGES
import AdminLoginPage from './Admin/loginPage'
import AdminLandingPage from './Admin/mainLandingPage'
import AddEmploiPage from './Admin/ajouterEmploi'

// PROFF PAGES
import ProffLoginPage from './Proff/loginPage'
import ProffLandingPage from './Proff/mainLandingPage'
import SeanceDataPage from './Proff/showSeance'

// ETUDIANT PAGES
import EtudiantLoginPage from './Etudiant/loginPage'
import EtudiantLandingPage from './Etudiant/mainLandingPage'
import PrintRapportAdmin from './Admin/printRapport';


function App() {
  /* Variabales  */
  const [progress, setProgress] = useState(2)

  /* Use Effects */
  useEffect(() => {
    setProgress(100);
  }, []);


  /* Component  */
  const RedirectionAdminPage = () => {
      const adminIsLogged = localStorage.getItem('AdminData');
      return (<>
          {
              adminIsLogged ? <Navigate to='/Admin/L'  /> : <Navigate to='/Admin/logIn'  />
          } 
  </>);}

  const RedirectionProffPage = () => {
      const adminIsLogged = localStorage.getItem('ProfData');
      return (<>
          {
              adminIsLogged ? <Navigate to='/Proff/L'  /> : <Navigate to='/Proff/logIn'  />
          } 
  </>);}

  const RedirectionEtudiantPage = () => {
      const adminIsLogged = localStorage.getItem('EtudiantData');
      return (<>
          {
              adminIsLogged ? <Navigate to='/Etudiant/L'  /> : <Navigate to='/Etudiant/logIn'  />
          } 
  </>);}

  const NotFound = () =>{
    return (<div className="cpntainer text-danger pt-5 text-center">
            <h1>Cette Page n'est pas Disponible  </h1>
             <img src='https://assets.ansl.tn/Images/usful/404.svg' width='200px' className='img-responsive ' />
             <br />
             <br />
             <a className='btn btn-danger text-white' href='../'>Retourner a la page d'acceuile </a>
        </div>);
  }

  
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />

          <Route path="Admin" exact element={<Outlet />} >
                  <Route path="" exact element={<RedirectionAdminPage />} />
                  <Route path="logIn" exact element={<AdminLoginPage />} />
                  <Route path="print-rapport" exact element={<PrintRapportAdmin />} />
                  <Route path="L" exact element={<Outlet />} >
                          <Route path="" exact element={<AdminLandingPage />} />
                          <Route path="addemp/:idp" exact element={<AddEmploiPage />} />  
                  </Route>
          </Route>
           
           <Route path="Proff" exact element={<Outlet />} >
                  <Route path="" exact element={<RedirectionProffPage />} />
                  <Route path="logIn" exact element={<ProffLoginPage />} />
                  <Route path="L" exact element={<Outlet />} >
                          <Route path="" exact element={<ProffLandingPage />} />
                           <Route path="seanceinfo/:ids/:groupe" exact element={<SeanceDataPage />} /> 
                  </Route>
          </Route>

          <Route path="Etudiant" exact element={<Outlet />} >
                  <Route path="" exact element={<RedirectionEtudiantPage />} />
                  <Route path="logIn" exact element={<EtudiantLoginPage />} />
                  <Route path="L" exact element={<Outlet />} >
                          <Route path="" exact element={<EtudiantLandingPage />} />
                           {/*<Route path="tickets" exact element={<TicketsPages />} />  */}
                  </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>   
      </Router>
      <LoadingBar color={GConf.themeColor} progress={progress} />
      <ToastContainer />
    </>
    
  );
}

export default App;
